import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TravelAgentProfileComponent } from '../travel-agent-profile/travel-agent-profile.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { TravelAgentProfileService } from '../travel-agent-profile.service';
import { TravelAgentProfile } from '../travel-agent-profile';

@Component({
    selector: 'app-travel-agent-profile-list',
    templateUrl: './travel-agent-profile-list.component.html',
    styleUrls: ['./travel-agent-profile-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class TravelAgentProfileListComponent implements OnInit {
	constructor(
		private travelAgentProfileService: TravelAgentProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = travelAgentProfileService.portalAcceses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	travelAgentProfiles: any;
	travelAgentProfile: TravelAgentProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'travelAgentProfileId', header: 'Id', width: 'auto' },
		{ field: 'firstName', header: 'First Name', width: 'auto' },
		{ field: 'lastName', header: 'Last Name', width: 'auto' },
		{ field: 'emailAddress', header: 'email', width: 'auto' },
		{ field: 'mobilePhone', header: 'mobile', width: 'auto' },
		{ field: 'iatalicNum', header: 'IATALicNum', width: 'auto' },
		{ field: 'defaultCommissionPCT', header: 'Default Commission PCT', width: 'auto' },
		{ field: 'portalRegisterDate', header: 'Portal RegisterDate', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.travelAgentProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-travelAgentProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.travelAgentProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.recordTotal = res.page.recordTotal;
						this.travelAgentProfiles = res.data.travelAgentProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(travelAgentProfile: TravelAgentProfile) {
		try {
			this.formLoading = true;
			this.travelAgentProfileService.update(travelAgentProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.travelAgentProfiles.map((travelAgentProfile, i) => {
							if (travelAgentProfile.travelAgentProfileId === res.data.travelAgentProfile.travelAgentProfileId) {
								this.travelAgentProfiles[i] = res.data.travelAgentProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(travelAgentProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(travelAgentProfile));

			this.formLoading = true;
			this.travelAgentProfileService.delete(travelAgentProfile.travelAgentProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.travelAgentProfiles.splice(this.travelAgentProfiles.indexOf(travelAgentProfile), 1);
						this.recordTotal = this.travelAgentProfiles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'TravelAgentProfile ' + travelAgentProfile.travelAgentProfileId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'TravelAgentProfile ' + travelAgentProfile.travelAgentProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Travel Agent Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TravelAgentProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addTravelAgentProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(travelAgentProfile: TravelAgentProfile) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			travelAgentProfile: travelAgentProfile,
			title: 'Edit Travel Agent Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TravelAgentProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateTravelAgentProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteTravelAgentProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addTravelAgentProfileCB(travelAgentProfile: TravelAgentProfile) {
		console.log('Adding TravelAgentProfile: ' + JSON.stringify(travelAgentProfile));
		// if we don't have a travelAgentProfiles array yet...
		if (!this.travelAgentProfiles) {
			this.travelAgentProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.travelAgentProfiles.unshift(travelAgentProfile);

		// no idea what this is but it is required to update the array
		this.travelAgentProfiles = [...this.travelAgentProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TravelAgentProfile ' + travelAgentProfile.travelAgentProfileId + ' Added', life: 3000 });
	}

	updateTravelAgentProfileCB(travelAgentProfile: TravelAgentProfile) {
		console.log('Updating TravelAgentProfile: ' + JSON.stringify(travelAgentProfile));
		let itemIndex = this.travelAgentProfiles.findIndex((item: any) => item.travelAgentProfileId === travelAgentProfile.travelAgentProfileId);
		this.travelAgentProfiles[itemIndex] = travelAgentProfile;

		// no idea what this is but it is required to update the array
		this.travelAgentProfiles = [...this.travelAgentProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TravelAgentProfile ' + travelAgentProfile.travelAgentProfileId + ' Updated', life: 3000 });
	}

	deleteTravelAgentProfileCB(travelAgentProfile: TravelAgentProfile) {
		console.log('Removing TravelAgentProfile: ' + travelAgentProfile);
		this.travelAgentProfiles.splice(this.travelAgentProfiles.indexOf(travelAgentProfile), 1);
		this.recordTotal = this.travelAgentProfiles.length;

		// no idea what this is but it is required to update the array
		this.travelAgentProfiles = [...this.travelAgentProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TravelAgentProfile ' + travelAgentProfile.travelAgentProfileId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.travelAgentProfiles ? this.first === (this.travelAgentProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.travelAgentProfiles ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(travelAgentProfile: any) {
		if (travelAgentProfile?.status) {
			const status = this.statuses.find((e: any) => e.value == travelAgentProfile.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
